module.exports = __webpack_public_path__ + "img/content_bg@2x.8d2dad32.png";